import { SceneNames } from '@Core/SceneNames';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameStoreEvents } from '@Managers/Events/GameStoreEvents';
import { Checkbox } from '@UILayer/Inputs/Checkbox';
import { DOM_ID } from '@UILayer/UILayer.types';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { RC_PRELOADER_DEFAULTS, TPreloaderState } from './Preloader.types';

// REDUX
import { getPreloaderState } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES
import infoIcon from '@Images/info_screen.png';

//PANELS & VIEWS

const PreloaderInfoScreenCheckbox: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: TPreloaderState, newState: Partial<TPreloaderState>) => ({ ...state, ...newState }), RC_PRELOADER_DEFAULTS);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const gameStorePreloaderState = useAppSelector(getPreloaderState);

    useEffect(() => {
        setState({
            currentScene: gameStorePreloaderState.currentScene,
            showIntroMovie: gameStorePreloaderState.showIntroMovie,
            showPreloaderInfo: gameStorePreloaderState.showPreloaderInfo
        });
    }, [gameStorePreloaderState]);

    function setLocalStorage() {
        if (state.currentScene === SceneNames.INTRO_MOVIE_SCENE) {
            EventsCenter.emit(EGameStoreEvents.GAME_STORE_PRELOADER_STATE_UPDATE, { showIntroMovie: !state.showIntroMovie });
        }

        if (state.currentScene === SceneNames.PRELOADER_INFO) {
            EventsCenter.emit(EGameStoreEvents.GAME_STORE_PRELOADER_STATE_UPDATE, { showPreloaderInfo: !state.showPreloaderInfo });
        }
    }

    function checkBoxValues() {
        let checked = true;
        if (state.currentScene === SceneNames.INTRO_MOVIE_SCENE) {
            checked = state.showIntroMovie;
        }
        if (state.currentScene === SceneNames.PRELOADER_INFO) {
            checked = state.showPreloaderInfo;
        }
        return {
            checked: checked,
            label: t('SETTINGS_DONT_SHOW_INFO_SCREEN_LABEL')
        };
    }

    return (
        <>
            <div className={styles.prealoder_checkbox}>
                <img className={styles.prealoder_checkbox_icon} src={infoIcon} alt="Info screen icon icon" />
                <Checkbox
                    id={DOM_ID.CHECKBOX_LOACL_STORAGE}
                    checked={checkBoxValues().checked}
                    ariaLabel={t('WCA_TOGGLE_INFO_SCREEN_BUTTON')}
                    onChange={setLocalStorage}
                    showLabel={false}
                />
            </div>
        </>
    );
};

export default PreloaderInfoScreenCheckbox;
